import React from 'react'
import async from '../components/Async'
import { Briefcase, Database} from 'react-feather'

// Dashboards components
const Default = async(() => import('./../pages/dashboards/index.js'))
const MyInduction = async(() => import('../pages/myInduction'))
const MySwms = async(() => import('../pages/mySwms'))
const MyTransfer = async(() => import('../pages/myTransfer'))
const MyItems = async(() => import('../pages/myItems'))

const Projects = async(() => import('../pages/projects'))
const Project = async(() => import('../pages/projects/project'))

const FatigueCalculator = async(() => import('../pages/projects/forms/fatigueCalculator'))
const Take5Assessment = async(() => import('../pages/projects/forms/Take5Assessment'))
const EditTake5Assessment = async(() => import('../pages/projects/forms/EditTake5Assessment'))
const CreateIncident = async(() => import('../pages/projects/forms/CreateIncident'))
const CreateEvent = async(() => import('../pages/projects/forms/CreateEvent'))
const CreateStkyEngagement = async(() => import('../pages/projects/forms/CreateStkyEngagement'))
const JourneyManagementPlan = async(() => import('../pages/projects/forms/journeyManagementPlan'))

const FatigueCalculatorReport = async(() => import('../pages/projects/reports/fatigueCalculator'))
const Take5AssessmentReport = async(() => import('../pages/projects/reports/Take5Assessment'))
const IncidentNotificationReport = async(() => import('../pages/projects/reports/incidentReport'))
const EventNotificationReport = async(() => import('../pages/projects/reports/eventNotification'))
const JourneyManagementPlanReport = async(() => import('../pages/projects/reports/journeyManagementPlanReport'));
const StkyEngagementReport = async(() => import('../pages/projects/reports/StkyEngagementReport'))
const UserActionReport = async(() => import('../pages/projects/reports/UserActionReport'))
const EditJourneyPlanner = async(() => import('../pages/projects/forms/editJourneyPlannerRoute'));
const ViewJourneyPlanner = async(() => import('../pages/projects/reports/viewForms/viewJourneyPlanner'));
const ViewTake5Assessment = async(() => import('../pages/projects/reports/viewForms/ViewTake5Assessment'));

const UserProfiles = async(() => import('../pages/userProfile'))
const StartCourse = async(() => import('../pages/myInduction/StartCourse'))
const Assessment = async(() => import('../pages/myInduction/Assessment'))

const EditIncidentReport = async(() => import('../pages/projects/forms/EditIncidentReport'))
const EditEventForm = async(() => import('../pages/projects/forms/EditEventNotification'))
const EditStkyEngagementForm = async(() => import('../pages/projects/forms/EditStkyEngagementForm'))
const UserActionForm = async(() => import('../pages/projects/forms/UserActionForm'))
const MyUserActionForm = async(() => import('../pages/projects/forms/MyUserActionForm'))


const ViewEventForm = async(() => import('../pages/projects/reports/viewForms/ViewEventNotification'))
const ViewIncidentForm = async(() => import('../pages/projects/reports/viewForms/ViewIncidentForm'))
const ViewStkyEngagementForm = async(() => import('../pages/projects/reports/viewForms/ViewStkyEngagementForm'))
const ViewUserActionForm = async(() => import('../pages/projects/reports/viewForms/ViewUserActionForm'))
const ViewHazardsForm = async(() => import('../pages/projects/reports/viewForms/ViewHazardsForm'))



const InspectionsList = async(() => import('../pages/projects/forms/inspections/index'))
const StartInspection = async(() => import('../pages/projects/forms/inspections/StartInspection'))
const ViewInspectionReport = async(() => import('../pages/projects/forms/inspections/ViewReport'))
const MyInspectionReports = async(() => import('../pages/projects/reports/InspectionReports'))
// Testing
const InspectionFormTest = async(() => import('../pages/projects/forms/formbuilder/InspectionFormTest'))

const HazardCollections = async(() => import('../pages/projects/forms/hazardCollections'))
const HazardCollectionsReport = async(() => import('../pages/projects/reports/hazardCollectionsReport'));
const MyUserActionsReport = async(() => import('../pages/projects/reports/myUserActionReport'));

//const AdminReports = async(() => import('../pages/projects/reports/admin'))
const TrainingRegister = async(() => import('../pages/projects/reports/admin/TrainingRegister'))
const TrainingMetrix = async(() => import('../pages/projects/reports/admin/TrainingMetrix'))
const Take5Report = async(() => import('../pages/projects/reports/admin/Take5Report'))
const UserActionsReport = async(() => import('../pages/projects/reports/admin/UserActionReport'))
const AdminInspectionReport = async(() => import('../pages/projects/reports/admin/InspectionReports'))
const AdminJourneyPlannerReport = async(() => import('../pages/projects/reports/admin/journeyManagementPlanReport'))
const AdminIncidentReport = async(() => import('../pages/projects/reports/admin/incidentReport'))
const AdminStkyEngagementReport = async(() => import('../pages/projects/reports/admin/StkyEngagementReport'))
const AdminUserLogReport = async(() => import('../pages/projects/reports/admin/userDailyLogReport'))

const UpdateContactDetails = async(() => import('../pages/userProfile/components/addEditUserProfileDetails/UpdateContactDetails'));
const AddUserQualifications = async(() => import('../pages/userProfile/components/addEditUserProfileDetails/AddUserQualifications'));
const UpdateUserQualifications = async(() => import('../pages/userProfile/components/addEditUserProfileDetails/UpdateUserQualifications'));
const AddUserCertificate = async(() => import('../pages/userProfile/components/addEditUserProfileDetails/AddUserCertificate'));
const UpdateUserCertificate = async(() => import('../pages/userProfile/components/addEditUserProfileDetails/UpdateUserCertificate'));
const AddUserLicense = async(() => import('../pages/userProfile/components/addEditUserProfileDetails/AddUserLicense'));
const UpdateUserLicense = async(() => import('../pages/userProfile/components/addEditUserProfileDetails/UpdateUserLicense'));
const AddUserOtherCertificate = async(() => import('../pages/userProfile/components/addEditUserProfileDetails/AddUserOtherCertificate'));
const UpdateUserOtherCertificate = async(() => import('../pages/userProfile/components/addEditUserProfileDetails/UpdateUserOtherCertificate'));

const CertificateReport = async(() => import('../pages/projects/reports/admin/CertificateReport'))
const InductionReport = async(() => import('../pages/projects/reports/admin/InductionReport'))
const LicenseReport = async(() => import('../pages/projects/reports/admin/LicenseReport'))
const OtherRecordsReport = async(() => import('../pages/projects/reports/admin/OtherRecordsReport'))
const QualificationReport = async(() => import('../pages/projects/reports/admin/QualificationReport'))

const getMenuIcon = (menuName) => {
  let menuMapper = {
    "Dashboard": <svg width="1200pt" height="1200pt" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                    <path d="m1096.8 438-424.8-380.4c-40.801-36-102-36-142.8 0l-426 380.4c-33.602 30-44.398 75.602-28.801 117.6 15.602 42 55.199 68.398 99.602 68.398v450c0 52.801 42 94.801 94.801 94.801h195.6c36 0 64.801-28.801 64.801-64.801l-0.003906-198c0-38.398 31.199-69.602 69.602-69.602 38.398 0 69.602 31.199 69.602 69.602v199.2c0 36 28.801 64.801 64.801 64.801h195.6c52.801 0 94.801-42 94.801-94.801l-0.003907-450c44.398 0 84-27.602 99.602-68.398 17.996-42 7.1953-88.801-26.402-118.8zm-163.2 637.2c0 1.1992-1.1992 3.6016-3.6016 3.6016h-168v-172.8c0-88.801-73.199-162-162-162s-162 73.199-162 162v171.6h-168c-1.1992 0-3.6016-1.1992-3.6016-3.6016v-448.8h667.2zm106.8-552c-1.1992 4.8008-6 9.6016-14.398 9.6016h-852c-8.3984 0-12-4.8008-14.398-9.6016-1.1992-4.8008-2.3984-10.801 3.6016-16.801l426-381.6c2.3984-2.3984 6-3.6016 9.6016-3.6016 3.6016 0 7.1992 1.1992 9.6016 3.6016l426 381.6c8.3945 6 7.1953 13.203 5.9922 16.801z" fill="#fff"/>
                  </svg>,
    "User Profile": <svg width="1200pt" height="1200pt" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                      <g fill="#fff" fillRule="evenodd">
                      <path d="m620 860c0 11.039-8.9414 20-20 20s-20-8.9609-20-20 8.9414-20 20-20 20 8.9609 20 20"/>
                      <path d="m817.97 1111.2c-3.9805 0-8-1.1797-11.5-3.6602l-36.082-25.418c-45.457-32.023-67.141-91-53.98-146.74 2.543-10.719 13.082-17.461 24.082-14.879 10.738 2.5391 17.398 13.301 14.859 24.039-9.4609 40.02 5.8398 82.18 38.082 104.9l36.078 25.422c9.0195 6.3398 11.199 18.84 4.8203 27.859-3.8789 5.5391-10.082 8.4805-16.359 8.4805"/>
                      <path d="m382.05 1111.2c-6.2812 0-12.461-2.9414-16.359-8.4805-6.3828-9.0195-4.2031-21.5 4.8203-27.859l36.117-25.461c32.223-22.719 47.5-64.859 38.043-104.86-2.543-10.738 4.1172-21.52 14.859-24.059 10.84-2.543 21.52 4.1172 24.078 14.879 13.16 55.719-8.5 114.68-53.938 146.72l-36.121 25.461c-3.5 2.4805-7.5195 3.6602-11.5 3.6602"/>
                      <path d="m89.961 40c-27.539 0-49.961 22.422-49.961 49.98v780.04c0 27.559 22.422 49.98 49.961 49.98h1020.1c27.539 0 49.961-22.422 49.961-49.98v-780.04c0-27.559-22.422-49.98-49.961-49.98zm1020.1 920h-1020.1c-49.602 0-89.961-40.359-89.961-89.98v-780.04c0-49.621 40.359-89.98 89.961-89.98h1020.1c49.602 0 89.961 40.359 89.961 89.98v780.04c0 49.621-40.359 89.98-89.961 89.98z"/>
                      <path d="m40 760h1120v-670.02c0-27.559-22.422-49.98-49.961-49.98h-1020.1c-27.539 0-49.961 22.422-49.961 49.98zm1160 40h-1200v-710.02c0-49.621 40.359-89.98 89.961-89.98h1020.1c49.602 0 89.961 40.359 89.961 89.98z"/>
                      <path d="m380 1120c-11.039 0-20 8.9805-20 20s8.9609 20 20 20h440c11.039 0 20-8.9805 20-20s-8.9609-20-20-20zm440 80h-440c-33.078 0-60-26.922-60-60s26.922-60 60-60h440c33.078 0 60 26.922 60 60s-26.922 60-60 60z"/>
                      <path d="m400 140c-143.36 0-260 116.64-260 260s116.64 260 260 260 260-116.64 260-260-116.64-260-260-260m0 560c-165.42 0-300-134.58-300-300s134.58-300 300-300 300 134.58 300 300-134.58 300-300 300"/>
                      <path d="m556.86 651.95c-4.5977 0-9.2383-1.582-13-4.8203-2.9805-2.5391-6.0195-4.6016-9.0781-6.1211l-75.5-38.559c-11.902-6.082-19.281-18.16-19.281-31.5v-23.082c0-7.9805 4.7617-15.199 12.102-18.359 30.316-13.059 50.059-38.02 60.277-76.301 1.7812-6.6406 6.8398-11.898 13.402-13.918 8.5195-2.6406 14.219-10.262 14.219-18.941v-20c0-7.2812-4.1797-14.02-10.898-17.559-5.8203-3.082-9.7617-8.8203-10.523-15.383-7.1367-60.84-43.699-87.957-118.58-87.957-3.2383 0-6.4219 0.11719-9.5195 0.35938-30.699 2.4375-58.922-3.3594-82.441-16.82 1.6992 15.418-0.75781 22.961-7.5391 37.52-1.8398 3.9414-4.1016 8.8203-6.7617 15.32-6.2969 15.359-10.477 32.66-12.438 51.418-0.69922 6.6211-4.6211 12.461-10.5 15.582-6.6602 3.5391-10.801 10.262-10.801 17.52v20c0 8.6797 5.6992 16.301 14.219 18.941 6.5625 2.0195 11.621 7.2773 13.402 13.918 10.238 38.281 29.957 63.242 60.297 76.301 7.3438 3.1602 12.082 10.379 12.082 18.359v22.922c0 13.598-7.582 25.738-19.781 31.738l-77.18 38.02c-1.9609 1.082-4.7188 3.0625-7.6406 5.6602-8.2578 7.3203-20.898 6.5391-28.238-1.7578-7.3203-8.2812-6.5391-20.922 1.7578-28.223 5.2227-4.6172 10.363-8.2773 15.723-11.199l75.359-37.141v-7.5195c-32.559-17.777-55.461-47.059-68.238-87.277-19.383-10.281-31.762-30.301-31.762-52.742v-20c0-18.359 8.4805-35.441 22.68-46.719 2.6992-18.961 7.3984-36.742 14.02-52.941 2.9805-7.2578 5.5-12.66 7.5391-17.059 5.4219-11.66 5.4219-11.66 1.543-31.16-1.8828-9.5391-3.1602-18.242-4-25.699-1.2422-10.801 4.6602-20.84 14.699-24.961 10.039-4.1211 21.34-1.1406 28.059 7.4609 3.9219 5 10.102 10.34 18.262 15.84 21.918 14.758 47.078 16.18 64.48 14.82 4.1602-0.32031 8.3789-0.48047 12.719-0.48047 91.738 0 144.5 38.32 156.98 113.92 14.418 11.281 23.02 28.48 23.02 46.98v20c0 22.441-12.379 42.461-31.762 52.742-12.758 40.219-35.68 69.5-68.238 87.277v7.7422l72.84 37.199c5.8008 2.8984 11.578 6.7812 17.02 11.461 8.4023 7.1797 9.3789 19.797 2.1797 28.199-3.9375 4.5977-9.5586 6.9805-15.18 6.9805"/>
                      <path d="m1060 120h-260c-11.059 0-20-8.9609-20-20s8.9414-20 20-20h260c11.059 0 20 8.9609 20 20s-8.9414 20-20 20"/>
                      <path d="m880 240h-80c-11.059 0-20-8.9609-20-20s8.9414-20 20-20h80c11.059 0 20 8.9609 20 20s-8.9414 20-20 20"/>
                      <path d="m960 360h-160c-11.059 0-20-8.9609-20-20s8.9414-20 20-20h160c11.059 0 20 8.9609 20 20s-8.9414 20-20 20"/>
                      <path d="m880 480h-80c-11.059 0-20-8.9609-20-20s8.9414-20 20-20h80c11.059 0 20 8.9609 20 20s-8.9414 20-20 20"/>
                      <path d="m880 720h-80c-11.059 0-20-8.9609-20-20s8.9414-20 20-20h80c11.059 0 20 8.9609 20 20s-8.9414 20-20 20"/>
                      <path d="m1060 720h-100c-11.059 0-20-8.9609-20-20s8.9414-20 20-20h100c11.059 0 20 8.9609 20 20s-8.9414 20-20 20"/>
                      <path d="m960 600h-160c-11.059 0-20-8.9609-20-20s8.9414-20 20-20h160c11.059 0 20 8.9609 20 20s-8.9414 20-20 20"/>
                      </g>
                    </svg>,
    "User Transfers": <svg width="1200pt" height="1200pt" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                        <path d="m814.27 1198.8c-30.812-2.7344-59.047-10.816-88.055-25.211-75.691-37.551-126.14-110.5-135.43-195.83-9.7305-89.324 33.434-180.45 109.1-230.32 97.168-64.051 223.88-52.422 308.1 28.27 38.676 37.051 65.137 89.191 72.664 143.17 2.5547 18.301 2.5547 49.91 0 68.211-8.9023 63.824-43.367 123.03-94.055 161.56-38.539 29.301-81.312 45.762-130.65 50.285-15.867 1.4531-24.086 1.4297-41.672-0.13281zm70.879-67.594c11.133-11.117 20.246-20.801 20.246-21.52s-31.211-32.512-69.359-70.652c-38.148-38.141-69.359-70.074-69.359-70.961 0-1.2383 6.082-1.6094 26.332-1.6094h26.332v-61.672l-159.91 0.66406v159.27l29.379 0.34375c20.594 0.24219 29.91-0.09375 31.148-1.1211 1.3867-1.1523 1.7656-6.8008 1.7656-26.355 0-13.688 0.43359-24.891 0.96875-24.891 0.53125 0 32.176 31.211 70.316 69.359 38.141 38.148 69.922 69.359 70.625 69.359 0.69922 0 10.383-9.0977 21.52-20.215zm127.82-208.09 0.33203-79.957h-61.672v26.332c0 14.48-0.42969 26.332-0.96094 26.332-0.52734 0-32.605-31.645-71.285-70.316l-70.328-70.316-43.008 43.008 141.27 141.94-26.652 0.34766c-24.211 0.31641-26.664 0.55078-26.793 2.5703-0.67188 10.605-0.36328 55.516 0.39844 57.781l0.97266 2.8984 157.4-0.66406zm-875.39 208.08c-3.0703-11.355-12.266-57.824-14.297-72.25-8.0352-57.062-7.7656-140.92 0.62891-195.23 11.211-72.57 30.973-135.82 61.188-195.88 37.422-74.367 92.18-138.79 153.54-180.61l13.164-8.9727 11.242 9.75c36.598 31.742 81.504 52.555 130.69 60.57 19.523 3.1797 58.824 3.1797 78.352 0 49.188-8.0156 94.094-28.828 130.69-60.57l11.242-9.75 13.164 8.9727c44.734 30.492 87.316 74.289 120.03 123.45 12.801 19.234 23.305 36.871 30.508 51.219 4.6172 9.1992 4.6719 9.4531 1.7695 8.7422-8.418-2.0664-38.172-3.6914-54.367-2.9648-41.602 1.8633-78.047 10.887-114.31 28.293-86.422 41.484-144.02 119-159.46 214.62-3.168 19.602-3.168 61.316 0 80.918 8.3828 51.895 30.195 100.88 61.719 138.58 4.6602 5.5742 8.4727 10.344 8.4727 10.598 0 0.25391-108.28 0.46094-240.63 0.46094l-240.64 0.007813zm381.84-688.3c-88.484-6.8281-161.84-60.977-193.78-143.04-11.086-28.488-16.59-66.254-13.875-95.234 5.9492-63.516 32.973-115.24 81.219-155.47 27.086-22.586 68.191-41.078 103.95-46.762 19.957-3.1719 51.969-3.1719 71.93 0 50.828 8.082 99.922 36.02 133.62 76.035 36.992 43.93 56.582 104.32 51.559 158.94-7.75 84.238-56.387 153.32-131.34 186.55-30.453 13.504-72.992 21.32-103.29 18.98z" fill="#fff"/>
                      </svg>,
    "Projects": <svg width="200px" height="200px" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                  <g fill="#fff">
                  <path d="m849.28 299.34c-6.6992 0-12.887 3.5742-16.238 9.375-3.3477 5.8008-3.3477 12.949 0 18.75 3.3516 5.8008 9.5391 9.375 16.238 9.375h44.344l-45.562 163.78c-1.4141 4.8125-0.83984 9.9883 1.5898 14.375 2.4297 4.3867 6.5195 7.6172 11.348 8.9688 1.6445 0.48047 3.3477 0.73438 5.0625 0.75 4.0938-0.015625 8.0703-1.375 11.32-3.8633s5.5938-5.9727 6.6797-9.918l48.375-173.44h85.969l48.469 173.72c1.0859 3.9453 3.4297 7.4297 6.6797 9.918s7.2266 3.8477 11.32 3.8633c1.7148-0.015625 3.418-0.26953 5.0625-0.75 4.8281-1.3516 8.918-4.582 11.348-8.9688 2.4297-4.3867 3.0039-9.5625 1.5898-14.375l-45.656-163.41h6.9375c6.6992 0 12.887-3.5742 16.238-9.375 3.3477-5.8008 3.3477-12.949 0-18.75-3.3516-5.8008-9.5391-9.375-16.238-9.375h-17.531l-33.375-119.44c17.414-10.16 30.062-26.844 35.141-46.355 5.0742-19.512 2.1641-40.246-8.0898-57.605-10.258-17.359-27.012-29.914-46.551-34.883v-22.969c0-6.6992-3.5742-12.887-9.375-16.238-5.8008-3.3477-12.949-3.3477-18.75 0-5.8008 3.3516-9.375 9.5391-9.375 16.238v22.969c-19.23 5.2539-35.617 17.875-45.605 35.129-9.9844 17.258-12.766 37.754-7.7383 57.047s17.457 35.824 34.594 46.012l-33.281 119.44zm93-3.4688 30.562-108.38h4.0312l30.656 108zm-4.7812-182.91c0-9.9453 3.9492-19.484 10.984-26.516 7.0312-7.0352 16.57-10.984 26.516-10.984s19.484 3.9492 26.516 10.984c7.0352 7.0312 10.984 16.57 10.984 26.516s-3.9492 19.484-10.984 26.516c-7.0312 7.0352-16.57 10.984-26.516 10.984s-19.484-3.9492-26.516-10.984c-7.0352-7.0312-10.984-16.57-10.984-26.516z"/>
                  <path d="m493.5 229.5c-1.4023-0.88281-2.9141-1.5781-4.5-2.0625l-1.5-0.65625c-85.594-31.781-154.12 27-178.12 62.625l-288.56 432.94c-7.8984 14.457-14.188 29.734-18.75 45.562-5.4375 30.707 1.4961 62.32 19.289 87.934 17.797 25.609 45.004 43.137 75.68 48.754l537.19 79.781 64.312-28.125-594.84-88.594c-20.945-3.8125-39.523-15.77-51.664-33.254-12.145-17.484-16.859-39.07-13.117-60.027 5.2812-22.598 20.668-41.512 41.719-51.281 27.348-13.426 59.512-12.727 86.25 1.875 4.1016 2.0742 8.8164 2.5703 13.258 1.3945 4.4414-1.1758 8.2969-3.9414 10.836-7.7695l207.56-312.28 419.16 53.062 10.312-36.469-406.12-51.375 77.156-115.97c2.7461-4.1836 3.707-9.2891 2.668-14.184-1.0391-4.8945-3.9922-9.1719-8.1992-11.879zm-325.22 454.88c-23.461-8.6953-48.883-10.676-73.406-5.7188l245.34-368.25c1.9688-2.9062 45.562-64.594 112.5-54.094z"/>
                  <path d="m1010.7 818.16 186.75-322.69c3.2109-5.4609 3.4492-12.172 0.62891-17.844-2.8164-5.6719-8.3086-9.5391-14.598-10.281l-50.906-6.375 6.8438 24.094c1.3438 4.8242 2.0391 9.8047 2.0625 14.812l9.375 1.125-198.56 342.75z"/>
                  <path d="m1168.9 789.38-536.53 236.81c-4.6211 2.0469-8.2188 5.8711-9.9805 10.609s-1.5352 9.9844 0.625 14.551c2.1641 4.5703 6.0781 8.0703 10.855 9.7148 0 0 405.28 138.94 407.34 138.94 3.8711 0.019531 7.6484-1.1641 10.82-3.3789 3.1719-2.2148 5.582-5.3555 6.8984-8.9961l135.38-375c1.2383-3.4531 1.4375-7.1953 0.57422-10.762-0.86719-3.5664-2.7617-6.8008-5.4492-9.3008-2.7266-2.4961-6.1289-4.1289-9.7852-4.6992-3.6523-0.56641-7.3906-0.039062-10.746 1.5117zm-139.12 368.16-338.44-116.44 452.44-199.69z"/>
                  <path d="m863.53 1040.6 142.12 48.844c4.6758 1.6562 9.8164 1.3906 14.297-0.73438 4.4805-2.1289 7.9336-5.9414 9.6094-10.609l47.906-132.75c1.2383-3.4531 1.4375-7.1953 0.57422-10.762-0.86719-3.5664-2.7617-6.8008-5.4492-9.3008-2.6992-2.5078-6.0742-4.1641-9.7109-4.7656-3.6328-0.60156-7.3633-0.11719-10.727 1.3906l-190.12 84c-4.6211 2.0469-8.2188 5.8711-9.9805 10.609s-1.5352 9.9844 0.625 14.551c2.1641 4.5703 6.0781 8.0703 10.855 9.7148zm163.59-66.75-26.812 74.156-79.406-27.281z"/>
                  <path d="m817.69 517.97-178.69-25.125c-3.293-0.47266-6.6484-0.0625-9.7305 1.1875-3.082 1.2539-5.7734 3.3008-7.8008 5.9375l-30.844 39.938-143.16-20.531c-3.3398-0.48828-6.7461-0.066406-9.8633 1.2227-3.1211 1.2852-5.832 3.3906-7.8555 6.0898 0 0-49.5 65.625-50.719 69.188-1.1211 4.8477-0.26953 9.9453 2.3672 14.164 2.6367 4.2227 6.8438 7.2188 11.695 8.3359 0 0 51.656 11.906 53.062 11.906 6.1641-0.10156 11.887-3.2305 15.301-8.3633 3.4141-5.1328 4.0859-11.617 1.8008-17.34-2.2891-5.7266-7.2461-9.9609-13.258-11.328l-20.344-4.7812 23.062-30.469 103.12 14.812-192.38 255.09-103.12-14.812 31.219-41.344s39.469 9.375 40.875 9.375c6.2188 0.050781 12.059-2.9883 15.586-8.1094 3.5312-5.1172 4.293-11.656 2.0312-17.449-2.2578-5.793-7.2422-10.09-13.305-11.473l-52.875-11.719c-5.8867-0.023438-11.438 2.7188-15 7.4062l-58.031 75.844c-3.9766 5.3047-4.8555 12.312-2.3164 18.438 2.543 6.1211 8.1289 10.445 14.691 11.375 0 0 484.69 68.531 485.53 68.531 5.8359 0.015625 11.348-2.6875 14.906-7.3125l223.22-288.94c4.0703-5.293 5.0195-12.352 2.4883-18.531s-8.1562-10.551-14.77-11.469l-121.88-17.156 17.531-22.688c4.0703-5.293 5.0195-12.352 2.4883-18.531s-8.1562-10.551-14.77-11.469zm-173.06 13.5 135.84 18.75-20.156 26.438-135.84-18.75zm-46.875 60.281 135.84 18.75-20.156 26.062-135.84-18.75zm-46.875 60.281 135.84 18.75-20.156 26.062-135.84-18.75zm-46.875 60.281 135.84 18.75-20.156 26.062-135.84-18.75zm-93.281 122.06 48-62.25 135.84 18.75-48 62.906zm486.47-213.94-30 38.812c-0.84375 0-52.688-12.562-52.688-12.562-4.9883-1.5391-10.395-0.92578-14.914 1.6914-4.5195 2.6133-7.7461 6.9961-8.8984 12.09s-0.125 10.438 2.8281 14.742c2.9531 4.3047 7.5664 7.1875 12.734 7.9453l36.281 8.5312-14.25 18-51.562-12.188c-4.9102-1.3516-10.156-0.65234-14.539 1.9453-4.3789 2.5938-7.5156 6.8594-8.6875 11.816-1.1719 4.9531-0.28125 10.172 2.4766 14.457 2.7539 4.2812 7.1289 7.2617 12.125 8.25l35.156 8.25-13.875 18-50.438-11.812c-4.9102-1.3516-10.156-0.65234-14.539 1.9453-4.3789 2.5938-7.5156 6.8594-8.6875 11.816-1.1719 4.9531-0.28125 10.172 2.4766 14.457 2.7539 4.2812 7.1289 7.2617 12.125 8.25l33.938 7.9688-14.25 17.906-49.312-11.531c-4.9102-1.3516-10.156-0.65234-14.539 1.9453-4.3789 2.5938-7.5156 6.8594-8.6875 11.816-1.1719 4.9531-0.28125 10.172 2.4766 14.457 2.7539 4.2812 7.1289 7.2617 12.125 8.25l32.812 7.6875-24.75 32.062-105.75-14.906 196.88-255z"/>
                  <path d="m401.34 680.44c4.9688 1.0078 10.133-0.035156 14.316-2.8945 4.1836-2.8633 7.0312-7.2969 7.8945-12.289 0.86328-4.9961-0.33594-10.129-3.3203-14.227-2.9805-4.0977-7.4961-6.8125-12.516-7.5273l-45.562-7.875c-3.625-0.55469-7.3359-0.03125-10.668 1.5-3.332 1.5352-6.1445 4.0117-8.082 7.125l-36 43.594c-2.8203 3.3984-4.3516 7.6836-4.3203 12.102 0.027343 4.4141 1.6172 8.6797 4.4805 12.039 2.8672 3.3594 6.8281 5.6016 11.184 6.3281l57.188 8.4375h2.8125c6.6992 0.48438 13.148-2.6406 16.918-8.1992 3.7695-5.5586 4.2891-12.703 1.3594-18.75-2.9297-6.043-8.8594-10.066-15.559-10.551l-24.281-3.5625 9.375-11.625z"/>
                  <path d="m941.34 436.97-10.312 36.469 91.031 11.531-11.156-39.188z"/>
                  </g>
                </svg>,
    "Inductions": <svg width="200px" height="200px" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                    <path d="m648 216c0 6.3633-2.5273 12.469-7.0312 16.969-4.5 4.5039-10.605 7.0312-16.969 7.0312s-12.469-2.5273-16.969-7.0312c-4.5039-4.5-7.0312-10.605-7.0312-16.969s2.5273-12.469 7.0312-16.969c4.5-4.5039 10.605-7.0312 16.969-7.0312s12.469 2.5273 16.969 7.0312c4.5039 4.5 7.0312 10.605 7.0312 16.969zm120 408c-6.3633 0-12.469 2.5273-16.969 7.0312-4.5039 4.5-7.0312 10.605-7.0312 16.969s2.5273 12.469 7.0312 16.969c4.5 4.5039 10.605 7.0312 16.969 7.0312s12.469-2.5273 16.969-7.0312c4.5039-4.5 7.0312-10.605 7.0312-16.969s-2.5273-12.469-7.0312-16.969c-4.5-4.5039-10.605-7.0312-16.969-7.0312zm312-432v480c0 19.094-7.5859 37.41-21.09 50.91-13.5 13.504-31.816 21.09-50.91 21.09h-204v96h132c12.73 0 24.938 5.0586 33.941 14.059 9 9.0039 14.059 21.211 14.059 33.941v24c0 12.73-5.0586 24.938-14.059 33.941-9.0039 9-21.211 14.059-33.941 14.059h-192v96c0 6.3633-2.5273 12.469-7.0312 16.969-4.5 4.5039-10.605 7.0312-16.969 7.0312h-576c-6.3633 0-12.469-2.5273-16.969-7.0312-4.5039-4.5-7.0312-10.605-7.0312-16.969v-310.08c0.007812-8.5664 4.582-16.48 12-20.762 32.816-19.035 70.062-29.094 108-29.16h8.5195c-35.371-28.445-60.887-67.312-72.914-111.08-12.027-43.77-9.9609-90.219 5.9062-132.75 15.867-42.531 44.73-78.977 82.488-104.17v-156c0-19.094 7.5859-37.41 21.09-50.91 13.5-13.504 31.816-21.09 50.91-21.09h672c19.094 0 37.41 7.5859 50.91 21.09 13.504 13.5 21.09 31.816 21.09 50.91zm-696 504c44.555 0 87.289-17.699 118.79-49.207 31.508-31.504 49.207-74.238 49.207-118.79s-17.699-87.289-49.207-118.79c-31.504-31.508-74.238-49.207-118.79-49.207s-87.289 17.699-118.79 49.207c-31.508 31.504-49.207 74.238-49.207 118.79s17.699 87.289 49.207 118.79c31.504 31.508 74.238 49.207 118.79 49.207zm312 216c0-29.488-7.7617-58.461-22.508-84-14.746-25.539-35.953-46.746-61.492-61.492-25.539-14.746-54.512-22.508-84-22.508h-288c-24.914 0.035156-49.508 5.6094-72 16.32v271.68h384v-97.922c0-8.5742 4.5742-16.496 12-20.781 7.4258-4.2891 16.574-4.2891 24 0 7.4258 4.2852 12 12.207 12 20.781v97.922h96zm60-72v-96h-92.52c31.305 25.023 55.027 58.262 68.52 96zm-13.441 48c0.96484 7.9648 1.4492 15.977 1.4414 24h192v-24zm289.44-696c0-6.3633-2.5273-12.469-7.0312-16.969-4.5-4.5039-10.605-7.0312-16.969-7.0312h-672c-6.3633 0-12.469 2.5273-16.969 7.0312-4.5039 4.5-7.0312 10.605-7.0312 16.969v132.6c7.8672-2.7969 15.879-5.1602 24-7.082v-101.52c0-6.3633 2.5273-12.469 7.0312-16.969 4.5-4.5039 10.605-7.0312 16.969-7.0312h192c8.5742 0 16.496 4.5742 20.785 12 4.2852 7.4258 4.2852 16.574 0 24-4.2891 7.4258-12.211 12-20.785 12h-168v72c49.191 0.066406 96.883 16.922 135.19 47.777 38.312 30.852 64.941 73.859 75.488 121.91 10.551 48.047 4.3828 98.25-17.48 142.32h46.801v-48c0.015625-23.602 6.9922-46.676 20.055-66.336 13.062-19.656 31.633-35.027 53.387-44.184-17.785-21.09-26.828-48.184-25.27-75.727 1.5586-27.543 13.598-53.445 33.648-72.395 20.051-18.949 46.594-29.504 74.18-29.504s54.129 10.555 74.18 29.504c20.051 18.949 32.09 44.852 33.648 72.395 1.5586 27.543-7.4844 54.637-25.27 75.727 21.754 9.1562 40.324 24.527 53.387 44.184 13.062 19.66 20.039 42.734 20.055 66.336v48h24v-384h-264c-8.5742 0-16.496-4.5742-20.785-12-4.2852-7.4258-4.2852-16.574 0-24 4.2891-7.4258 12.211-12 20.785-12h288c6.3633 0 12.469 2.5273 16.969 7.0312 4.5039 4.5 7.0312 10.605 7.0312 16.969v432c0 6.3633-2.5273 12.469-7.0312 16.969-4.5 4.5039-10.605 7.0312-16.969 7.0312h-144c-8.5742 0-16.496-4.5742-20.785-12-4.2852-7.4258-4.2852-16.574 0-24 4.2891-7.4258 12.211-12 20.785-12h48v-48c0-19.094-7.5859-37.41-21.09-50.91-13.5-13.504-31.816-21.09-50.91-21.09h-72c-19.094 0-37.41 7.5859-50.91 21.09-13.504 13.5-21.09 31.816-21.09 50.91v48h24c8.5742 0 16.496 4.5742 20.785 12 4.2852 7.4258 4.2852 16.574 0 24-4.2891 7.4258-12.211 12-20.785 12h-151.44c-7.7305 8.6328-16.113 16.656-25.078 24h488.52c6.3633 0 12.469-2.5273 16.969-7.0312 4.5039-4.5 7.0312-10.605 7.0312-16.969zm-252 264c15.914 0 31.176-6.3203 42.426-17.574 11.254-11.25 17.574-26.512 17.574-42.426s-6.3203-31.176-17.574-42.426c-11.25-11.254-26.512-17.574-42.426-17.574s-31.176 6.3203-42.426 17.574c-11.254 11.25-17.574 26.512-17.574 42.426s6.3203 31.176 17.574 42.426c11.25 11.254 26.512 17.574 42.426 17.574z" fill="#fff"/>
                  </svg>,
    "SWMS": <svg width="1200pt" height="1200pt" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
              <g fill="#fff">
              <path d="m790.07 120h-564.37c-42.457 0-77.004 34.535-77.004 77.004v806c0 42.457 34.535 77.004 77.004 77.004h564.37c42.457 0 77.004-34.535 77.004-77.004v-806c-0.011718-42.469-34.547-77.004-77.004-77.004zm52.992 883c0 29.219-23.773 53.004-53.004 53.004h-564.36c-29.219 0-53.004-23.773-53.004-53.004v-805.99c0-29.219 23.773-53.004 53.004-53.004h564.37c29.219 0 53.004 23.773 53.004 53.004v805.99z"/>
              <path d="m310.23 265.18c-25.441 0-46.129 20.688-46.129 46.129 0 25.441 20.699 46.129 46.129 46.129s46.129-20.699 46.129-46.129c0-25.43-20.688-46.129-46.129-46.129zm0 68.258c-12.203 0-22.129-9.9258-22.129-22.129 0-12.203 9.9258-22.129 22.129-22.129s22.129 9.9258 22.129 22.129c0 12.203-9.9219 22.129-22.129 22.129z"/>
              <path d="m752.02 299.3h-316.21c-6.625 0-12 5.375-12 12s5.375 12 12 12h316.22c6.625 0 12-5.375 12-12s-5.375-12-12.012-12z"/>
              <path d="m310.23 442.64c-25.441 0-46.129 20.688-46.129 46.129 0 25.441 20.699 46.129 46.129 46.129s46.129-20.699 46.129-46.129c0-25.43-20.688-46.129-46.129-46.129zm0 68.254c-12.203 0-22.129-9.9258-22.129-22.129s9.9258-22.129 22.129-22.129 22.129 9.9258 22.129 22.129c0 12.207-9.9219 22.129-22.129 22.129z"/>
              <path d="m752.02 476.76h-316.21c-6.625 0-12 5.375-12 12s5.375 12 12 12h316.22c6.625 0 12-5.375 12-12s-5.375-12-12.012-12z"/>
              <path d="m310.23 620.1c-25.441 0-46.129 20.699-46.129 46.129 0 25.43 20.699 46.129 46.129 46.129s46.129-20.688 46.129-46.129c0-25.441-20.688-46.129-46.129-46.129zm0 68.254c-12.203 0-22.129-9.9258-22.129-22.129 0-12.203 9.9258-22.129 22.129-22.129s22.129 9.9258 22.129 22.129c0 12.207-9.9219 22.129-22.129 22.129z"/>
              <path d="m752.02 654.23h-316.21c-6.625 0-12 5.375-12 12s5.375 12 12 12h316.22c6.625 0 12-5.375 12-12 0-6.6211-5.375-12-12.012-12z"/>
              <path d="m310.23 797.55c-25.441 0-46.129 20.699-46.129 46.129 0 25.43 20.699 46.129 46.129 46.129s46.129-20.688 46.129-46.129-20.688-46.129-46.129-46.129zm0 68.258c-12.203 0-22.129-9.9258-22.129-22.129s9.9258-22.129 22.129-22.129 22.129 9.9258 22.129 22.129-9.9219 22.129-22.129 22.129z"/>
              <path d="m752.02 831.7h-316.21c-6.625 0-12 5.375-12 12s5.375 12 12 12h316.22c6.625 0 12-5.375 12-12s-5.375-12-12.012-12z"/>
              <path d="m1050.8 905.95c0.14453-0.74219 0.44531-1.4883 0.44531-2.2305 0-0.011718 0.011719-0.023437 0.011719-0.035156v-666.96c0-21.996-17.902-39.898-39.91-39.898h-72.406c-21.996 0-39.898 17.902-39.898 39.898v666.96c0 0.011719 0.011719 0.023438 0.011719 0.035156 0 0.74219 0.30078 1.4766 0.44531 2.2305 0.16797 0.82812 0.19141 1.7031 0.51563 2.4609 0 0.011719 0 0.023438 0.011718 0.023438l64.105 148.61c1.8945 4.4023 6.2266 7.2461 11.016 7.2461s9.1211-2.8438 11.016-7.2461l64.117-148.61c0-0.011719 0-0.023438 0.011719-0.023438 0.31641-0.75781 0.35156-1.6328 0.50781-2.4609zm-127.77-590.47h40.043v576.21h-40.043zm64.047 0h40.176v576.21h-40.176zm-48.133-94.656h72.406c8.7734 0 15.91 7.1289 15.91 15.898v54.758h-104.22v-54.758c-0.011719-8.7578 7.1289-15.898 15.902-15.898zm36.203 801.18-45.863-106.31h91.738z"/>
              </g>
            </svg>,
  "Reports": <svg width="1200pt" height="1200pt" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
            <g fill="#fff">
            <path d="m993.75 37.5h-675c-14.918 0-29.227 5.9258-39.773 16.477-10.551 10.547-16.477 24.855-16.477 39.773v56.25h-56.25c-14.918 0-29.227 5.9258-39.773 16.477-10.551 10.547-16.477 24.855-16.477 39.773v900c0 14.918 5.9258 29.227 16.477 39.773 10.547 10.551 24.855 16.477 39.773 16.477h675c14.918 0 29.227-5.9258 39.773-16.477 10.551-10.547 16.477-24.855 16.477-39.773v-56.25h56.25c14.918 0 29.227-5.9258 39.773-16.477 10.551-10.547 16.477-24.855 16.477-39.773v-900c0-14.918-5.9258-29.227-16.477-39.773-10.547-10.551-24.855-16.477-39.773-16.477zm-93.75 1068.8c0 4.9727-1.9766 9.7422-5.4922 13.258-3.5156 3.5156-8.2852 5.4922-13.258 5.4922h-675c-4.9727 0-9.7422-1.9766-13.258-5.4922-3.5156-3.5156-5.4922-8.2852-5.4922-13.258v-900c0-4.9727 1.9766-9.7422 5.4922-13.258 3.5156-3.5156 8.2852-5.4922 13.258-5.4922h506.25v150c0 5.4023 2.3281 10.543 6.3906 14.102 4.0625 3.5625 9.4609 5.1992 14.816 4.4922 5.3555-0.71094 10.145-3.6914 13.145-8.1875l21.898-32.906 21.898 32.852c2.9961 4.4883 7.7773 7.4688 13.125 8.1836 5.3477 0.71094 10.746-0.91406 14.809-4.4648 4.0664-3.5469 6.4023-8.6758 6.418-14.07v-150h56.25c4.9727 0 9.7422 1.9766 13.258 5.4922 3.5156 3.5156 5.4922 8.2852 5.4922 13.258zm-150-918.75h37.5v88.125l-3.1484-4.7266c-3.4805-5.2148-9.332-8.3477-15.602-8.3477s-12.121 3.1328-15.602 8.3477l-3.1484 4.7266zm262.5 806.25c0 4.9727-1.9766 9.7422-5.4922 13.258-3.5156 3.5156-8.2852 5.4922-13.258 5.4922h-56.25v-806.25c0-14.918-5.9258-29.227-16.477-39.773-10.547-10.551-24.855-16.477-39.773-16.477h-581.25v-56.25c0-4.9727 1.9766-9.7422 5.4922-13.258 3.5156-3.5156 8.2852-5.4922 13.258-5.4922h675c4.9727 0 9.7422 1.9766 13.258 5.4922 3.5156 3.5156 5.4922 8.2852 5.4922 13.258z"/>
            <path d="m806.25 487.5h-525c-4.9727 0-9.7422 1.9766-13.258 5.4922-3.5156 3.5156-5.4922 8.2852-5.4922 13.258v412.5c0 4.9727 1.9766 9.7422 5.4922 13.258 3.5156 3.5156 8.2852 5.4922 13.258 5.4922h525c4.9727 0 9.7422-1.9766 13.258-5.4922 3.5156-3.5156 5.4922-8.2852 5.4922-13.258v-412.5c0-4.9727-1.9766-9.7422-5.4922-13.258-3.5156-3.5156-8.2852-5.4922-13.258-5.4922zm-18.75 112.5h-337.5v-75h337.5zm-243.75 37.5h56.25v262.5h-56.25zm-37.5 262.5h-56.25v-262.5h56.25zm131.25-262.5h56.25v262.5h-56.25zm-225-112.5v75h-112.5v-75zm-112.5 112.5h112.5v262.5h-112.5zm431.25 262.5v-262.5h56.25v262.5z"/>
            <path d="m262.5 337.5h150v37.5h-150z"/>
            <path d="m262.5 262.5h37.5v37.5h-37.5z"/>
            <path d="m337.5 262.5h75v37.5h-75z"/>
            <path d="m468.75 412.5h150v37.5h-150z"/>
            <path d="m789.38 1000.5c-9.7656-15.84-27.039-25.484-45.648-25.484-18.605 0-35.879 9.6445-45.645 25.484-7.5 9.0938-10.539 12.02-16.875 12.02-6.3359 0-9.2812-2.9258-16.875-12-10.191-15.355-27.164-24.859-45.582-25.52v37.5c6.3359 0 9.375 2.9258 16.875 12.02 9.7656 15.844 27.051 25.496 45.664 25.496 18.617 0 35.898-9.6523 45.668-25.496 7.5-9.0742 10.539-12 16.875-12 6.0195 0 8.832 2.3984 16.875 12 10.18 15.344 27.141 24.832 45.543 25.48v-37.5c-6.0195 0-8.832-2.3984-16.875-12z"/>
            </g>
          </svg>
  }
  return menuMapper[menuName] || <Briefcase/>
}

const dashboardsRoutes = {
  id: 'Dashboard',
  path: '/',
  // path: '/dashboard',
  icon: getMenuIcon('Dashboard'),
  component: Default,
  children: null
}

const myInductionRoutes = {
  id: 'My Induction',
  path: '/myInduction',
  icon: getMenuIcon('Inductions'),
  component: MyInduction,
  children: null,
  onlineOnly: true
}

const mySwmsRoutes = {
  id: 'My SWMS',
  path: '/MySwms',
  icon: getMenuIcon('SWMS'),
  component: MySwms,
  children: null,
  onlineOnly: true
}

const myTransferRoutes = {
  id: 'My Transfer',
  path: '/MyTransfer',
  icon: getMenuIcon('User Transfers'),
  component: MyTransfer,
  children: null,
  onlineOnly: true
}

const myItemRoutes = {
  id: 'My Items',
  path: '/MyItems',
  icon: getMenuIcon('Reports'),
  component: MyItems,
  children: null,
  onlineOnly: true
}

const StartCourseRoutes = {
  id: 'StartCourse',
  path: '/myInduction/StartCourse/:inductionId',
  component: StartCourse
}

const AssessmentRoutes = {
  id: 'Assessment',
  path: '/myInduction/Assessment/:inductionId',
  component: Assessment
}
const projectsRoutes = {
  id: 'My Projects',
  path: '/projects',
  icon: getMenuIcon('Projects'),
  component: Projects,
  children: null
}

const ProjectRoute = {
  id: 'ProjectDetails',
  path: '/projects/:projectId',
  component: Project
}

const FatigueCalculatorRoute = {
  id: 'FatigueCalculator',
  path: '/projects/forms/fatigueCalculator/:projectId',
  component: FatigueCalculator
}

const Take5AssessmentRoute = {
  id: 'Take5Assessment',
  path: '/projects/forms/take5assessment/:projectId',
  component: Take5Assessment
}

const Take5AssessmentEditRoute = {
  id: 'EditTake5Assessment',
  path: '/MyItems/Take5Assessment/Edit/:take5Id',
  component: EditTake5Assessment
}

const CreateIncidentRoute = {
  id: 'CreateIncident',
  path: '/projects/forms/CreateIncident/:projectId',
  component: CreateIncident
}

const JourneyManagementPlanRoute = {
  id: 'JourneyManagementPlan',
  path: '/projects/forms/journeyManagementPlan/:projectId',
  component: JourneyManagementPlan
};

const EditJourneyPlannerRoute = {
  id: 'EditJourneyPlanner',
  path: '/MyItems/journeyManagementPlanReport/Edit/:journeyId',
  component: EditJourneyPlanner
};

const ViewJourneyPlannerRoute = {
  id: 'ViewJourneyPlanner',
  path: '/MyItems/journeyManagementPlanReport/View/:journeyId',
  component: ViewJourneyPlanner
};

const EditIncidentReportRoute = {
  id: 'EditIncidentReport',
  path: '/MyItems/incidentReport/Edit/:incidentId',
  component: EditIncidentReport
}

const EditEventFormRoute = {
  id: 'EditEventForm',
  path: '/MyItems/EventNotification/Edit/:eventId',
  component: EditEventForm
}

const EditStkyEngagementFormRoute = {
  id: 'StkyEngagementForm',
  path: '/MyItems/StkyEngagementReport/Edit/:stkyId',
  component: EditStkyEngagementForm
}

const ViewEventFormRoute = {
  id: 'ViewEventForm',
  path: '/MyItems/EventNotification/View/:eventId',
  component: ViewEventForm
}

const ViewIncidentFormRoute = {
  id: 'ViewEventForm',
  path: '/MyItems/incidentReport/View/:incidentId',
  component: ViewIncidentForm
}

const ViewStkyEngagementFormRoute = {
  id: 'ViewEventForm',
  path: '/MyItems/StkyEngagementReport/View/:stkyEngagementId',
  component: ViewStkyEngagementForm
}

const ViewUserActionFormRoute = {
  id: 'ViewUserActionForm',
  path: '/projects/reports/ViewUserActionForm/:actionId',
  component: ViewUserActionForm
}

const ViewHazardsFormRoute = {
  id: 'ViewHazardsForm',
  path: '/MyItems/hazardCollectionsReport/View/:hazardId',
  component: ViewHazardsForm
}

const CreateEventRoute = {
  id: 'CreateEvent',
  path: '/projects/forms/CreateEvent/:projectId',
  component: CreateEvent
}

const CreateStkyEnagagementRoute = {
  id: 'CreateStkyEngagement',
  path: '/projects/forms/CreateStkyEngagement/:projectId',
  component: CreateStkyEngagement
}

const EventNotificationReportRoute = {
  id: 'EventNotificationReport',
  path: '/MyItems/EventNotification',
  component: EventNotificationReport
}

const JourneyManagementReportRoute = {
  id: 'JourneyManagementPlanReport',
  path: '/MyItems/journeyManagementPlanReport',
  component: JourneyManagementPlanReport
};

const StkyEngagementReportRoute = {
  id: 'StkyEngagementReport',
  path: '/MyItems/StkyEngagementReport',
  component: StkyEngagementReport
}

const UserActionReportRoute = {
  id: 'UserActionReport',
  path: '/projects/reports/UserActionReport/:actionDueDate',
  component: UserActionReport
}

const InductionStatusRoutes = {
  id: 'My Induction',
  path: '/myInduction/:inductionStatus',
  component: MyInduction,
}

const SwmsRoutes = {
  id: 'My Swms',
  path: '/MySwms',
  component: MySwms,
}

const FatigueCalculatorReportRoute = {
  id: 'FatigueCalculatorReport',
  path: '/MyItems/fatigueCalculator',
  component: FatigueCalculatorReport
}

const Take5AssessmentReportRoute = {
  id: 'Take5AssessmentReport',
  path: '/MyItems/Take5assessment',
  component: Take5AssessmentReport
}

const IncidentNotificationReportRoute = {
  id: 'IncidentNotificationReport',
  path: '/MyItems/incidentReport',
  component: IncidentNotificationReport

}

const userRoutes = {
  id: 'User Profile',
  path: '/userProfile',
  icon: getMenuIcon('User Profile'),
  component: UserProfiles,
  children: null
}

const UserActionFormRoute = {
  id: 'UserActionForm',
  path: '/projects/UserActionForm/:actionDueDate/:actionId',
  component: UserActionForm
}

const MyUserActionFormRoute = {
  id: 'MyUserActionForm',
  path: '/MyItems/UserActionForm/:actionStatus/:actionId',
  component: MyUserActionForm
}

const inspectionFormTestRoute = {
  id: 'DataInitalise',
  path: '/internal/InspectionFormTest',
  icon: <Database />,
  component: InspectionFormTest,
  children: null
}


const InspectionsListRoute = {
  id: 'Inspections List',
  path: '/projects/inspections/:projectId',
  component: InspectionsList,
  children: null
}

const StartInspectionsRoute = {
  id: 'Start Inspection',
  path: '/projects/inspections/start-inspection/:templateId',
  component: StartInspection
}

// const InspectionReportRoute = {
//   id: 'Inspection Reports',
//   path: '/MyItems/Inspection',
//   component: InspectionReports
// }

const MyInspectionReportsRoute = {
  id: 'My Inspection Reports',
  path: '/MyItems/InspectionReport',
  component: MyInspectionReports
}

const ViewInspectionReportRoute = {
  id: 'Inspection Reports',
  path: '/MyItems/InspectionReport/View/:id',
  component: ViewInspectionReport
}


const ViewTake5AssessmentRoute = {
  id: 'ViewTake5Assessment',
  path: '/MyItems/Take5Assessment/View/:take5Id',
  component: ViewTake5Assessment
}

const hazardCollectionsRoute = {
  id: 'HazardCollections',
  path: '/projects/forms/hazardCollections/:projectId',
  component: HazardCollections
};

const hazardCollectionsReportRoute = {
  id: 'HazardCollectionsReport',
  path: '/MyItems/hazardCollectionsReport',
  component: HazardCollectionsReport
};

const myUserActionsReportRoute = {
  id: 'MyUserActionsReport',
  path: '/MyItems/myUserActionReport',
  component: MyUserActionsReport
};

const trainingRegisterRoute = {
  id: 'Training Register Report',
  path: '/projects/reports/adminReports/trainingRegister',
  component: TrainingRegister
}

const trainingMetrixRoute = {
  id: 'Training Metrix Report',
  path: '/projects/reports/adminReports/trainingMetrix',
  component: TrainingMetrix
}

const certificateReportRoute = {
  id: 'Certificate Report',
  path: '/projects/reports/adminReports/CertificateReport',
  component: CertificateReport
}

const inductionReportRoute = {
  id: 'Induction Report',
  path: '/projects/reports/adminReports/InductionReport',
  component: InductionReport
}

const licenseReportRoute = {
  id: 'License Report',
  path: '/projects/reports/adminReports/LicenseReport',
  component: LicenseReport
}

const qualificationReportRoute = {
  id: 'Qualification Report',
  path: '/projects/reports/adminReports/QualificationReport',
  component: QualificationReport
}

const otherRecordsReportRoute = {
  id: 'Other Records Report',
  path: '/projects/reports/adminReports/OtherRecordsReport',
  component: OtherRecordsReport
}

const take5ReportRoute = {
  id: 'Take 5 Assessment Report',
  path: '/projects/reports/adminReports/Take5assessment',
  component: Take5Report
}

const adminUserActionsReportRoute = {
  id: 'User Actions Report',
  path: '/projects/reports/adminReports/userActionsReport',
  component: UserActionsReport
}

const adminInspectionReportRoute = {
  id: 'User Actions Report',
  path: '/projects/reports/adminReports/inspectionsReport',
  component: AdminInspectionReport
}

const adminJourneyPlannerReportRoute = {
  id: 'User Actions Report',
  path: '/MyItems/journeyManagementPlanReport',
  component: AdminJourneyPlannerReport
}

const adminIncidentReportRoute = {
  id: 'User Actions Report',
  path: '/projects/reports/adminReports/incidentReport',
  component: AdminIncidentReport
}

const adminStkyEngagementReportRoute = {
  id: 'User Actions Report',
  path: '/projects/reports/adminReports/stkyEngagementReport',
  component: AdminStkyEngagementReport
}

const adminUserLogReportRoute = {
  id: 'User Actions Report',
  path: '/projects/reports/adminReports/userLogReport',
  component: AdminUserLogReport
}

const updateUserContactDetails = {
  id: 'UpdateContactDetails',
  path: '/userProfile/components/addEditUserProfileDetails/UpdateContactDetails',
  component: UpdateContactDetails
};

const addUserQualifications = {
  id: 'AddUserQualifications',
  path: '/userProfile/components/addEditUserProfileDetails/AddUserQualifications',
  component: AddUserQualifications
};

const updateUserQualifications = {
  id: 'UpdateUserQualifications',
  path: '/userProfile/components/addEditUserProfileDetails/UpdateUserQualifications/:qualificationId',
  component: UpdateUserQualifications
};

const addUserCertifications = {
  id: 'AddUserCertificate',
  path: '/userProfile/components/addEditUserProfileDetails/AddUserCertificate',
  component: AddUserCertificate
};

const updateUserCertificate = {
  id: 'UpdateUserCertificate',
  path: '/userProfile/components/addEditUserProfileDetails/UpdateUserCertificate/:certificationId',
  component: UpdateUserCertificate
};

const addUserLicense = {
  id: 'AddUserLicense',
  path: '/userProfile/components/addEditUserProfileDetails/AddUserLicense',
  component: AddUserLicense
};

const updateUserLicence = {
  id: 'UpdateUserLicense',
  path: '/userProfile/components/addEditUserProfileDetails/UpdateUserLicense/:licenseId',
  component: UpdateUserLicense
};

const addUserOtherCertificate = {
  id: 'AddUserOtherCertificate',
  path: '/userProfile/components/addEditUserProfileDetails/AddUserOtherCertificate',
  component: AddUserOtherCertificate
};

const updateUserOtherCertificate = {
  id: 'UpdateUserOtherCertificate',
  path: '/userProfile/components/addEditUserProfileDetails/UpdateUserOtherCertificate/:recordId',
  component: UpdateUserOtherCertificate
};

// Routes using the Dashboard layout
export const dashboardLayoutRoutes = [
  dashboardsRoutes,
  myInductionRoutes,
  mySwmsRoutes,
  myTransferRoutes,
  myItemRoutes,  
  userRoutes,
  StartCourseRoutes,
  AssessmentRoutes,
  projectsRoutes,
  ProjectRoute,
  FatigueCalculatorRoute,
  Take5AssessmentRoute,
  CreateIncidentRoute,
  CreateEventRoute,
  CreateStkyEnagagementRoute,
  JourneyManagementPlanRoute,
  EditIncidentReportRoute,
  EditEventFormRoute,
  EditStkyEngagementFormRoute,
  ViewEventFormRoute,
  ViewIncidentFormRoute,
  ViewStkyEngagementFormRoute,
  ViewUserActionFormRoute,
  ViewHazardsFormRoute,
  EditJourneyPlannerRoute,
  ViewJourneyPlannerRoute,
  Take5AssessmentReportRoute,
  IncidentNotificationReportRoute,
  FatigueCalculatorReportRoute,
  EventNotificationReportRoute,
  JourneyManagementReportRoute,
  StkyEngagementReportRoute,
  UserActionReportRoute,
  InductionStatusRoutes,
  UserActionFormRoute,
  MyUserActionFormRoute,
  Take5AssessmentEditRoute,
  inspectionFormTestRoute,
  InspectionsListRoute,
  StartInspectionsRoute,
  ViewInspectionReportRoute,
  ViewTake5AssessmentRoute,
  hazardCollectionsRoute,
  hazardCollectionsReportRoute,
  myUserActionsReportRoute,
  MyInspectionReportsRoute,
  trainingRegisterRoute,
  trainingMetrixRoute,
  certificateReportRoute,
  inductionReportRoute,
  licenseReportRoute,
  qualificationReportRoute,
  otherRecordsReportRoute,
  take5ReportRoute,
  updateUserContactDetails,
  addUserQualifications,
  updateUserQualifications,
  addUserCertifications,
  updateUserCertificate,
  addUserLicense,
  updateUserLicence,
  addUserOtherCertificate,
  updateUserOtherCertificate
]

// Routes visible in the sidebar
export const sidebarRoutes = [
  dashboardsRoutes, 
  userRoutes, 
  projectsRoutes,
  myInductionRoutes,
  mySwmsRoutes,
  myTransferRoutes,
  myItemRoutes
]